import { render, staticRenderFns } from "./ManageAccessUser.vue?vue&type=template&id=0df84d62&lang=pug"
import script from "./ManageAccessUser.vue?vue&type=script&lang=js"
export * from "./ManageAccessUser.vue?vue&type=script&lang=js"
import style0 from "./ManageAccessUser.vue?vue&type=style&index=0&id=0df84d62&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports